export default "__VITE_ASSET__BCVZ2Y2b__"